import api from "@/lib/api";

/** Fire-and-forget CTA click tracking for the SEO Hub. */
export const trackCta = (label) => {
  try {
    api.post("/track/view", { type: "cta", slug: `${window.location.pathname}|${label}` }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
};
